
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class FlowerOfLifeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const r = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, r);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawCircle = (cx: number, cy: number, radius: number) => {
            ctx.beginPath();
            ctx.arc(cx, cy, radius * scale, 0, Math.PI * 2);
            ctx.stroke();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += r) {
                for (let y = y1; y <= y2; y += r * Math.sqrt(3) / 2) {
                    const offset = (Math.round(y / (r * Math.sqrt(3) / 2)) % 2 === 0) ? 0 : r / 2;
                    drawCircle(x + offset, y, r);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
